import React from 'react';
import {useShallow} from 'zustand/react/shallow';
import {Stack} from '@mui/material';
import {
  designSystemToken,
  Headline,
  Tooltip,
} from '@lightricks/react-design-system';
import useUiInteractionEvent from '@contentlab/hooks/analytics/use-interaction-event';
import translate from '@/utils/translate';
import {ROUTES} from '@/config/routesConstants';
import {Feature} from '@/views/content-studio/components/feature-page/types';
import NavLink from '@/components/nav-link';
import contentStudioStore from '@/stores/contentStudioStore';
import FeaturePage from '../feature-page/FeaturePage';
import FeaturePageNavItem from '../feature-page/FeaturePageNavItem';
import ManyToManyEditor from '../many-to-many-editor/ManyToManyEditor';

const features: Feature[] = [
  {
    icon: 'Actions-Expand',
    label: 'Resize',
    path: ROUTES.CONTENT_LAB_REFORMAT,
  },
  {
    icon: 'Navigation-Messages',
    label: 'Dub',
    path: ROUTES.CONTENT_LAB_TRANSLATE,
  },
  {
    icon: 'Features-Rename',
    label: 'Rephrase',
    path: ROUTES.CONTENT_LAB_REPHRASE,
  },
];

function EmptyFeaturePage() {
  const {uiInteraction} = useUiInteractionEvent();
  const {isRephraseActive} = contentStudioStore(
    useShallow((state) => ({
      isRephraseActive: state.selectedAssets.length === 1,
    }))
  );

  return (
    <FeaturePage>
      <ManyToManyEditor
        flowName="empty_feature_page"
        asset_page_route={ROUTES.CONTENT_LAB_FEATURE_ASSETS}
        backgroundColor={designSystemToken('semantic.bg.secondary')}
      >
        <Stack marginTop="120px">
          <Headline size="lg" align="center">
            {translate('How would you like to edit these videos?')}
          </Headline>
          <Stack
            direction="row"
            justifyContent="center"
            gap="16px"
            marginTop="36px"
          >
            {features.map((feature) => {
              if (
                feature.path === ROUTES.CONTENT_LAB_REPHRASE &&
                !isRephraseActive
              ) {
                return (
                  <Tooltip
                    key={feature.path}
                    title={translate('To rescript, select only one file')}
                    arrow
                    placement="bottom"
                  >
                    <span>
                      <FeaturePageNavItem
                        icon={feature.icon}
                        label={translate(feature.label)}
                        isActive={false}
                        backgroundColor={designSystemToken(
                          'semantic.bg.tertiary'
                        )}
                        buttonSize="150px"
                        disabled
                        labelSize="lg"
                        borderRadius="12px"
                        gap="19px"
                      />
                    </span>
                  </Tooltip>
                );
              }
              return (
                <NavLink
                  to={feature.path}
                  key={feature.path}
                  onClick={() => {
                    uiInteraction({
                      item_name: feature.label,
                      interaction_location: 'empty_editor',
                    });
                  }}
                >
                  {({isActive}) => (
                    <FeaturePageNavItem
                      icon={feature.icon}
                      label={translate(feature.label)}
                      isActive={isActive}
                      backgroundColor={designSystemToken(
                        'semantic.bg.tertiary'
                      )}
                      buttonSize="150px"
                      labelSize="lg"
                      borderRadius="12px"
                      gap="19px"
                    />
                  )}
                </NavLink>
              );
            })}
          </Stack>
        </Stack>
      </ManyToManyEditor>
    </FeaturePage>
  );
}

export default EmptyFeaturePage;
